import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';
import { routes } from '../../../constants/routes';

@Component({
  selector: 'app-back-button',
  standalone: true,
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss',
})
export class BackButtonComponent {
  routes = routes;
  isMobile: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    public router: Router,
  ) {}

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.isMobile = window.innerWidth < 768;
  }
}
